"use client";

import dynamic from "next/dynamic";
import React from "react";

type Props = {
    children: React.ReactNode;
};

// @see: https://blog.bitsrc.io/using-non-ssr-friendly-components-with-next-js-916f38e8992c
// if you see an error (BAILOUT_TO_CLIENT_SIDE_RENDERING) in the DOM please read this: https://github.com/vercel/next.js/issues/63272#issuecomment-2051361188
const ClientOnly: React.FC<Props> = ({ children }) => {
    return <>{children}</>;
};

export default dynamic(() => Promise.resolve(ClientOnly), {
    ssr: false,
});
